import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { TherapyModel } from '../../models/TherapyModel'

export interface TherapyState {
    Therapy: TherapyModel
    TherapyList: TherapyModel[]
}

const initialState: TherapyState = {
    Therapy: {
        Id: 0,
        TherapyName:'',
        Rate: 0,
        Duration: 0,
        GSTId: 0,
        GSTValue: '',
    },
    TherapyList: [],
}

export const TherapySlice = createSlice({
    name: 'therapy',
    initialState,
    reducers: {
        setTherapies: (state, action: PayloadAction<TherapyModel[]>) => {
            state.TherapyList = action.payload
        },
        saveTherapy: (state, action: PayloadAction<TherapyModel>) => {
            let model = action.payload
            if (model.Id > 0) {
                let defaultModel: TherapyModel = {
                    Id: model.Id,
                    TherapyName: model.TherapyName,
                    Rate: model.Rate,
                    Duration : model.Duration,
                    GSTId: model.GSTId,
                    GSTValue: model.GSTValue
                }
                let currentModel = state.TherapyList.find((c) => c.Id === model.Id) || defaultModel
                currentModel.TherapyName = model.TherapyName
                currentModel.Rate = model.Rate
                currentModel.Duration = model.Duration
                currentModel.GSTId = model.GSTId
                currentModel.GSTValue= model.GSTValue
            } else {
                model.Id = (Math.max(...state.TherapyList.map((c) => c.Id)) || 0) + 1
                state.TherapyList.push(model)
            }
        },
        getTherapyById: (state, action: PayloadAction<number>) => {
            let id = action.payload
            let model: TherapyModel = initialState.Therapy
            if (id > 0) {
                let currentList: TherapyModel[] = state.TherapyList
                model = currentList.find((c) => c.Id === id) || initialState.Therapy
            }

            state.Therapy = model
        },
        deleteTherapy: (state, action: PayloadAction<string>) => {
            let id: string = action.payload
            let ids: number[] = id.split(',').map((i) => parseInt(i))
            if (ids && ids.length > 0) {
                let currentList: TherapyModel[] = state.TherapyList
                state.TherapyList = currentList.filter((c) => !ids.includes(c.Id))
            }
        },
    },
})

export const { setTherapies, saveTherapy, getTherapyById, deleteTherapy } =
TherapySlice.actions

export default TherapySlice.reducer
